import React from "react";
import { AppProvider, AppContext } from "../../stores/application.store";
import Home from "../Pages/Home/Home";
import { useRef } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import Footer from "../Footer/Footer";
import "./PageView.scss";
import ThankYou from "../Pages/ThankYou/ThankYou";
import Carousel from "../Animations/Carousel/Carousel";
const PageView = () => {
  const { setShareOpen, pageView, setDidChoose, setPageView, voteOver } = useContext(
    AppContext
  );

  const mainSection = useRef();
  useEffect(() => {
    if (localStorage.getItem("glgltz_vote_int") == "true") {
      setPageView(4);
      setDidChoose(true);
      window.dataLayer.push({
        event: "virtualPageview",
        virtualPageURL: "/glgltz-international/multiple-participation",
        virtualPageTitle: "המצעד הבינלאומי השנתי - כבר השתתפת בפעילות",
      });
    }

    mainSection.current.addEventListener("click", () => {
      setShareOpen(false);
    });
  }, []);

  return (
    <div ref={mainSection} className="page-view">
      {pageView == 0 && <Home />}
      {(pageView == 1 || pageView == 2 || pageView == 3) && <Carousel />}
      {pageView == 4 && <ThankYou />}
      <Footer />
    </div>
  );
};

export default PageView;
